const s = "inbound", o = "Customer", t = "outbound", n = "Reply to Bot/Message", T = {
  [s]: ["UserMessage", "BotIntroMessage"],
  [t]: [
    "BotAutoMessage",
    "VisitorAutoMessage",
    "AutoMessage",
    "TriggeredMessage",
    "ManualMessage",
    "CampaignMessage",
    "DisplayableContent"
  ]
}, a = [
  { value: "user", text: "User (Leads & Contacts)" },
  { value: "teammate", text: "Teammate" }
], g = a.map((e) => e.value);
export {
  T as CONVERSATION_TYPE_MAPPINGS,
  s as INBOUND,
  o as INBOUND_TEXT,
  t as OUTBOUND,
  n as OUTBOUND_TEXT,
  a as PARTICIPANT_TYPES,
  g as PARTICIPANT_TYPE_VALUES
};
